/**
 * useIsMobile — retorna true quando viewport < breakpoint (default 640px).
 *
 * Reage a resize. Usado nos painéis flutuantes do master pra evitar
 * sobreposição entre MasterControlsPill (bottom-left) e
 * MasterActivityControls (que em mobile vira top-right colapsável).
 */

import { useEffect, useState } from 'react'

export function useIsMobile(breakpoint = 640): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.innerWidth < breakpoint
  })

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [breakpoint])

  return isMobile
}
